import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "../../return-to-checkout-modal.module.css";
import { ModalState } from "../../return-to-checkout-modal.types";
import { VehicleInformation } from "../../vehicle-information/vehicle-information.component";
import { Primary, Text } from "@cinch-labs/design-system";
import React, { useEffect } from "react";
export var ReturnToCheckoutExpiredStillAvailable = function(param) {
    var i18n = param.i18n, vehicle = param.vehicle, onButtonClick = param.onButtonClick, title = param.title, isButtonLoading = param.isButtonLoading, adminFeeFlag = param.adminFeeFlag, adminFeeValueInPence = param.adminFeeValueInPence, trackEvent = param.trackEvent, noOpTracking = param.noOpTracking, onModalOpen = param.onModalOpen;
    useEffect(function() {
        onModalOpen(ModalState.expiredStillAvailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentWrapper,
        children: [
            title,
            /*#__PURE__*/ _jsx(Text, {
                fontWeight: "light",
                fontSize: "s",
                children: i18n.text
            }),
            /*#__PURE__*/ _jsx(VehicleInformation, {
                vehicle: vehicle,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent
            }),
            /*#__PURE__*/ _jsx(Primary, {
                isLoading: isButtonLoading,
                classNames: {
                    button: styles.button
                },
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            })
        ]
    });
};
